import { lazyWithRetry } from '@repo/error';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';
import type { AppRouteObject } from '@router/types';

const PasswordResetPage = lazyWithRetry(() => import('@features/auth/pages/PasswordResetPage'));

export const authRoutes: AppRouteObject[] = [
  {
    path: ROUTE_PATHS[RouteName.AUTH_PASSWORD_RESET],
    name: RouteName.AUTH_PASSWORD_RESET,
    element: <PasswordResetPage />,
  },
];
